import React, {useEffect, useState} from 'react'
import {ModalTitle, Timeline, Icon} from '@thryvlabs/maverick'
import dayjs from 'dayjs'
import {Spinner} from '../../../loader-spinner'

export const KPLoadingTimelineModal = ({currentStep = 1}) => {
  const [timelineEvents, setTimelineEvents] = useState([
    {
      eventTitle: <p>Gathering Your Account Details</p>,
      eventSubtitle: dayjs().format('MMMM D [at] h:mm A'),
      icon: <Icon variant="lock" type="solid" color="white" />,
      theme: 'primary',
    },
    {
      eventTitle: <p>...loading</p>,
      eventSubtitle: '',
      icon: <Icon variant="calendar" type="solid" color="#A7A7A7" />,
      theme: 'neutral',
    },
    {
      eventTitle: <p>...loading</p>,
      eventSubtitle: '',
      icon: <Icon variant="calendar" type="solid" color="#A7A7A7" />,
      theme: 'neutral',
    },
  ])

  const newTitles = {
    1: <p>Creating My Account</p>,
    2: <p>Go Time!</p>,
  }

  useEffect(() => {
    if (currentStep <= 2) {
      setTimelineEvents(prevTimelineEvents => {
        const copyOfTimeline = prevTimelineEvents.map(event => ({...event}))
        console.log({
          copyOfTimeline,
          currentStep,
          newTitles,
          currentEventTitle: newTitles[currentStep],
        })
        copyOfTimeline[currentStep].eventTitle = newTitles[currentStep]
        copyOfTimeline[currentStep].eventSubtitle =
          dayjs().format('MMMM D [at] h:mm A')
        copyOfTimeline[currentStep].icon = (
          <Icon variant="lock" type="solid" color="white" />
        )
        copyOfTimeline[currentStep].theme = 'primary'
        return copyOfTimeline
      })
    }
  }, [currentStep])

  return (
    <>
      <div className="flex gap-4">
        <div className="whitespace-nowrap m-auto">
          <ModalTitle variant="primary">Creating Account</ModalTitle>
        </div>
        <Spinner />
      </div>
      <Timeline events={timelineEvents} />
    </>
  )
}
